import '../styles/galaxy.css';

// Cutoffs in ascending order. Crossing one of these (and never having shown
// it before) triggers the congratulatory popup the next time the user lands
// on the galaxy/universe/collision canvas.
export const MILESTONES = [1, 10, 25, 50, 100, 250, 500, 1000];

const MESSAGES = {
  1: {
    title: 'First star, lit.',
    body: "You've placed the first artist in your universe. Every galaxy starts with one. Keep going and watch yours grow.",
  },
  10: {
    title: '10 artists charted.',
    body: 'A constellation is forming. Keep exploring. The more artists you mark, the richer the connections become.',
  },
  25: {
    title: '25 artists strong.',
    body: "Your taste is taking shape. You're building a real picture of the music you love.",
  },
  50: {
    title: 'Half a hundred.',
    body: "50 artists mapped. You're well on your way to a universe that's unmistakably yours.",
  },
  100: {
    title: '100 artists. A real universe.',
    body: 'Triple digits. Your map has the depth to surface genuinely surprising connections now.',
  },
  250: {
    title: '250 artists explored.',
    body: 'This is a serious musical world. Few users get this far, and your universe is one of a kind.',
  },
  500: {
    title: '500 artists. Stellar territory.',
    body: 'A vast, intricate map of your taste. Thank you for building this with us.',
  },
  1000: {
    title: '1,000 artists. Legendary.',
    body: 'A thousand artists explored. Your universe is its own galaxy now. Keep charting the unknown.',
  },
};

export function milestoneFor(count, lastShown) {
  if (!Number.isFinite(count) || count <= 0) return 0;
  let highest = 0;
  for (const m of MILESTONES) {
    if (count >= m && m > lastShown) highest = m;
  }
  return highest;
}

function MilestoneModal({ milestone, onClose, onViewAchievements }) {
  const msg = MESSAGES[milestone] || {
    title: `${milestone} artists explored!`,
    body: 'Your universe keeps growing. Keep exploring.',
  };

  return (
    <div className="galaxy-info-overlay" onClick={onClose}>
      <div
        className="galaxy-info-modal milestone-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="milestone-title"
      >
        <button className="galaxy-info-close" onClick={onClose} aria-label="Dismiss">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="milestone-badge">
          <span className="milestone-badge-count">{milestone.toLocaleString()}</span>
          <span className="milestone-badge-label">{milestone === 1 ? 'artist' : 'artists'}</span>
        </div>

        <h3 id="milestone-title" className="galaxy-info-title milestone-title">{msg.title}</h3>
        <p className="galaxy-info-text milestone-body">{msg.body}</p>

        <button className="milestone-cta" onClick={onClose}>
          Keep exploring
        </button>

        {onViewAchievements && (
          <button className="milestone-secondary" onClick={onViewAchievements}>
            View achievements
          </button>
        )}
      </div>
    </div>
  );
}

export default MilestoneModal;
